import {
  Component,
  OnInit,
  TemplateRef,
  OnDestroy,
  AfterContentInit
} from '@angular/core';
import {
  SEOService,
  AuctionService,
  LoaderService,
  CmsService,
  AuctionDataReqType,
} from '../../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import routeTable from '../../../../utility/routeTable';
import { AuctionTimeService } from '../../../../services/auction-time.service';
import constants from '../../../../utility/constants';
import { AuctionCurrentState } from '../../../../models';
import { CalendarOptions, ICalendar } from 'datebook';
import {  Subscription } from 'rxjs';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-auction-details',
  templateUrl: './auction-details.component.html',
  styleUrls: ['./auction-details.component.css'],
})
export class AuctionDetailsComponent implements OnInit, OnDestroy, AfterContentInit {
  modalRef: BsModalRef;
  pageNumber = 1;
  pageSize = 24;
  isPaginated = true;
  responseData: any;
  showView: boolean = false;
  helpTextData: string;
  steps = SteppedData;
  private subscriptions: Array<Subscription> = [];
  auctionCode: string;

  currentSlider: any = [];
  currentSliderHeader: string;
  showImage = '';
  selectedImage: any;
  showBlank: boolean;

  config = {
    class: 'custom-popup lot-images-slider modal-dialog modal-dialog-centered',
  };

  // step number
  stepActive = 1;

  auctionDetailsSlider = {
    infinite: true,
    autoplay: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  imagesSlider2 = {
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.view-more-slider .thumbs',
  };

  thumbnailsSlider2 = {
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    asNavFor: '.view-more-slider .image-slides2',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  lotLogistics = {
    infinite: true,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    asNavFor: '.lotNav',
  };

  lotLogisticsNav = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    asNavFor: '.lotHeader',
  };

  forPublicClient: boolean = false;
  auctionId: number;
  tAndC: string;
  routes = routeTable.public;

  returnUrl: string = '/';

  isBiddingOpen: boolean;

  registrationFormats = constants.common.saletypeRegistrationFormat;
  auctionStatuses = constants.common.auctionStatus;
  displaySections = constants.common.displaySection;
  helpTexts = constants.common.helpText;

  auctionCurrentState: AuctionCurrentState;
  isLots: boolean;

  relatedAuctions: Array<any>;
  contacts: Array<any>;
  locations: Array<any>;

  photoGallery: Array<any> = [];
  photoGalleryThumbnail: Array<any> = [];
  showPhotoGalleryThumbnail: Array<any> = [];
  sliderImages: Array<any>;
  sliderImagesThumbnail: Array<any>;
  removalDocuments: Array<any>;
  paymentDocuments: Array<any>;
  partnerLogos: Array<any>;
  customButtons: Array<any>;

  constructor(
    private auctionService: AuctionService,
    private cmsService: CmsService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private auctionTimeService: AuctionTimeService,
    private seoService: SEOService
  ) {}

  loadPrettyPhoto(): void {
    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    };

    waitForElm('.prettyPhotoWrapper').then((elm) => {
      //@ts-ignore
      $('a[rel^="prettyPhoto"]').prettyPhoto({
          animationSpeed: 'slow',
          theme: 'dark_rounded'
      });
    })

    waitForElm('.prettyPhotoSlideWrapper').then((elm) => {
      //@ts-ignore
      $('a[rel^="prettyPhoto"]').prettyPhoto({
          animationSpeed: 'slow',
          theme: 'dark_rounded'
      });
    })
  }

  ngAfterContentInit(): void {
    this.loadPrettyPhoto();
  }

  ngOnInit(): void {
    this.route.fragment.subscribe((fragment: string) => {
      if (fragment == 'terms') {
        this.stepActive = 3;
      }
    });

    this.route.params.subscribe((params) => {
      this.auctionCode = params['auctionCode'];
      if (this.auctionCode) {
        let getAuctionByCode$ = this.getAuctionByCode();
        let getStepWiseDataLoc$ = this.getStepWiseData(this.steps.auctionLocations);
        let getStepWiseDataCon$ = this.getStepWiseData(this.steps.auctionContacts);
        let getStepWiseDataImg$ = this.getStepWiseData(this.steps.sliderImages);
        let getStepWiseDataLog$ = this.getStepWiseData(this.steps.partnerLogos);
        let getStepWiseDataAuc$ = this.getStepWiseData(this.steps.relatedAuctions);
        let getCustomButtons$ = this.getCustomButtons();

        forkJoin([
          getAuctionByCode$,
          getStepWiseDataCon$,
          getStepWiseDataImg$,
          getStepWiseDataLog$,
          getStepWiseDataLoc$,
          getStepWiseDataAuc$,
          getCustomButtons$,
        ]).subscribe(() => {
          this.route.queryParams.subscribe((params) => {
            if (params['ics'] == "true") {
              setTimeout(() => {
                this.createCalenderEvent();
              }, 500)
            }
          });
        })
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params['returnTo'];
    });

    this.getResolverData();
  }

  getResolverData() {
    this.route.data.subscribe((res: any) => {
      this.auctionCurrentState = res['auctionState'];
      if (this.auctionCurrentState) {
        this.isLots = this.auctionCurrentState.isInHouseLotConfigured;
        this.checkBiddingOpen(this.auctionCurrentState);
        this.checkAuctionDeactivated(this.auctionCurrentState);
      }
    });
  }

  checkBiddingOpen(auctionState: AuctionCurrentState) {
    if (
      auctionState.status === this.auctionStatuses.live &&
      !auctionState.saleType.isCatalogReadOnly
    )
      this.isBiddingOpen = this.auctionTimeService.isBiddingOpen(
        this.auctionCurrentState.startDateTimeUtc,
        this.auctionCurrentState.closingEndDateTimeUtc
      );
  }

  getButtonText(data: any) {
    if (!data.saleType.isCatalogUploadAllowed && this.isWithinTimeRange(data.startDateTime, data.endDateTime)) {
      return "Bid Now"
    }
    return "Lot Catalog"
  }

  isWithinTimeRange(startDateTime, endDateTime) {
    const startTime = new Date(startDateTime);
    const endTime = new Date(endDateTime);
    // Add 12 hours to the end time
    const extendedEndTime = new Date(endTime.getTime() + 12 * 60 * 60 * 1000);
    const currentTime = new Date();
    return currentTime > startTime && currentTime < extendedEndTime;
  }

  private checkAuctionDeactivated(auctionState: AuctionCurrentState) {
    // this block says when an auction is in pending and open to show for client
    if (
      auctionState.isSentForApproval &&
      auctionState.status === this.auctionStatuses.pending
    ) {
      this.forPublicClient = true;
      return;
    }

    // this block says when an auction is not in pending and open to all users
    if (
      !auctionState.isActive &&
      !auctionState.isApproved &&
      auctionState.status !== this.auctionStatuses.pending
    ) {
      if (!auctionState.saleType.isCatalogReadOnly) {
        this.toastr.info(
          `Unfortunately ${this.auctionCode} is no longer available for bidding and you will be notified if and when the auction becomes available for bidding again`,
          constants.common.toast.infoTitle,
          constants.common.toast.config
        );
      }
      if (auctionState.saleType.isCatalogReadOnly) {
        this.toastr.info(
          `Unfortunately ${this.auctionCode} is deactivated and you will be notified if and when the auction becomes available again`,
          constants.common.toast.infoTitle,
          constants.common.toast.config
        );
      }
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  getTandC() {
    const getCMSPublic = this.cmsService
      .GetCmsPublic(constants.common.cmsPages.termsAndConditions)
      .subscribe((res) => {
        this.tAndC = res;
      });
      this.subscriptions.push(getCMSPublic)
  }

  private setSeoTags(response: any) {
    this.seoService.setPageTitle(response['pageTitle']);
    this.seoService.setMetaTagDescription(response['metaDescription']);
    this.seoService.setMetaTagKeywords(response['keywords']);
  }
  changeSteps(stepNum: number) {
    this.stepActive = stepNum;
    switch (stepNum) {
      case 2:
        this.showBlank = true;
        this.getStepWiseData(this.steps.photoGallery);
        break;
      case 3:
        this.getStepWiseData(this.steps.paymentDocuments);
        this.getTandC();
        break;
      case 4:
        this.getStepWiseData(this.steps.removalDocuments);
        break;
    }
    this.loadPrettyPhoto();
  }

  openHelpModal(template: TemplateRef<any>) {
    let helpTextId: number;
    if (
      this.responseData.saleType.showHelpText === this.helpTexts.catalogBidding
    )
      helpTextId = constants.common.cmsPages.helpTextCatalogWithBidding;
    else if (
      this.responseData.saleType.showHelpText === this.helpTexts.readOnlyCatalog
    )
      helpTextId = constants.common.cmsPages.helpTextReadOnlyCatalog;
    this.loader.showLoader(true);
    const getCMSPublic = this.cmsService.GetCmsPublic(helpTextId).subscribe((res) => {
      this.helpTextData = res;
      this.loader.showLoader(false);
      this.modalRef = this.modalService.show(template, {
        class:
          'custom-popup auction-help-modal modal-dialog modal-dialog-centered',
      });
    });
    this.subscriptions.push(getCMSPublic)
  }

  getAuctionByCode() {
    return new Promise((resolve, reject) => {
      this.showView = false;
      this.loader.showLoader(true);
      const auctionDetail = this.auctionService.getAuctionDetailByCode(this.auctionCode).subscribe(
        (response: any) => {
          if (response === null) {
            this.goToBack();
            reject(new Error("Auction not found")); // Reject the Promise with an error message
          } else {
            this.responseData = response;
            this.showView = true;
            this.loader.showLoader(false);
            this.setSeoTags(response);
            resolve(response); // Resolve the Promise with the response data
          }
        },
        (err) => {
          this.showView = true;
          this.loader.showLoader(false);
          this.goToBack();
          reject(err); // Reject the Promise with the error object
        }
      );
      this.subscriptions.push(auctionDetail);
    });
  }

  goToBack() {
    this.router.navigateByUrl(this.returnUrl);
  }

  goToViewDetail(id: number, numberOfStepsBack: number = 1) {
    let routeFragments = this.router.url.split('/');
    let returnUrl = routeFragments
      .splice(0, routeFragments.length - numberOfStepsBack)
      .join('/');
    this.router.navigate([returnUrl, id], { relativeTo: this.route });
  }

  showGallery() {
    if (this.photoGalleryThumbnail && this.photoGalleryThumbnail.length)
      this.showPhotoGalleryThumbnail = this.photoGalleryThumbnail.slice(
        (-1 + this.pageNumber) * this.pageSize,
        this.pageNumber * this.pageSize
      );
  }

  goToRegister() {
    this.router.navigate([routeTable.public.auctionRegister], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url },
    });
  }

  onPageChange(paging: number) {
    this.pageNumber = paging;
    this.showGallery();
    setTimeout(() => {
      this.loadPrettyPhoto();
    }, 500)
  }

  scrollToTop(stepNum: number, el: HTMLElement) {
    el.scrollIntoView();
    this.stepActive = stepNum;
    this.changeSteps(stepNum);
  }

  goToEnquiryPage() {
    this.router.navigate([routeTable.public.enquire], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url },
    });
  }

  isNumberOrStringNumber(input) {
    //@ts-ignore
    if (typeof input === 'number' || (typeof input === 'string' && !isNaN(input))) {
      return true;
    } else {
      return false;
    }
  }

  goToLotsSection() {
    this.router.navigate([routeTable.public.auctionLot], {
      relativeTo: this.route,
      queryParams: { returnTo: this.router.url },
    });
  }

  createCalenderEvent() {
    let locations = [];
    if (this.locations && this.locations.length)
      this.locations.forEach((loc) => locations.push(loc.name));

    let title = `${this.responseData?.title} Auction | The Branford Group`;
    let desc = `${this.responseData?.tagline?.replace(/<[^>]+>/g, '')} \n ${
      location.href.replace(/(\?|&)ics=true/g, '')
    }`;
    let startDate = new Date(`${this.responseData?.startDateTimeUtc}Z`);
    let endDate = new Date(`${this.responseData?.endDateTimeUtc}Z`);

    let config: CalendarOptions = {
      title: title,
      location: locations.join(', '),
      description: desc,
      start: startDate,
      end: endDate,
    };
    let icalendar = new ICalendar(config);
    icalendar.addProperty(
      'CATEGORIES',
      `${this.responseData?.saleType?.publicName}`
    );
    icalendar.addProperty('URL', `${location.href}`);
    icalendar.download();
  }

  private async getStepWiseData(stepData: number): Promise<void> {
    const reqTypes = AuctionDataReqType;
    const assetTypes = constants.admin.assetType;
    // Wrap the whole function logic in a Promise
    return new Promise<void>((resolve, reject) => {
      let publicAuctionData: any;
      switch (stepData) {
        case this.steps.auctionLocations:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.locations, this.auctionCode);
          break;
        case this.steps.photoGallery:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.images, this.auctionCode, assetTypes.photoGallery);
          break;
        case this.steps.removalDocuments:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.documents, this.auctionCode, assetTypes.document);
          break;
        case this.steps.paymentDocuments:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.documents, this.auctionCode, assetTypes.paymentDocument);
          break;
        case this.steps.auctionContacts:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.contacts, this.auctionCode);
          break;
        case this.steps.relatedAuctions:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.relatedAuctions, this.auctionCode);
          break;
        case this.steps.partnerLogos:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.images, this.auctionCode, assetTypes.partnerLogo);
          break;
        case this.steps.sliderImages:
          publicAuctionData = this.auctionService.getPublicAuctionData(reqTypes.images, this.auctionCode, assetTypes.sliderImage);
          break;
        default:
          reject(new Error('Invalid stepData value'));
          return;
      }
      // Use async/await to wait for the subscription to resolve
      const subscription = publicAuctionData.subscribe(
        (res: any) => {
          switch (stepData) {
            case this.steps.auctionLocations:
              this.locations = res;
              break;
            case this.steps.photoGallery:
              this.photoGalleryThumbnail = res.map((it: any) => {
                let name = it.thumbnailName;
                it.thumbnailName = it.thumbnailName.replace('/images/', '/thumbnails/');
                return { id: it.id, name: name, thumb: it.thumbnailName, order: it.order };
              });
              this.photoGallery = res.map((it: any) => {
                return { id: it.id, name: it.name, order: it.order };
              });
              this.showGallery();
              this.showBlank = false;
              break;
            case this.steps.removalDocuments:
              this.removalDocuments = res;
              break;
            case this.steps.paymentDocuments:
              this.paymentDocuments = res;
              break;
            case this.steps.auctionContacts:
              this.contacts = res;
              break;
            case this.steps.relatedAuctions:
              this.relatedAuctions = res;
              break;
            case this.steps.partnerLogos:
              this.partnerLogos = res;
              break;
            case this.steps.sliderImages:
              this.sliderImagesThumbnail = res.map((it) => {
                let name = it.thumbnailName;
                it.thumbnailName = it.thumbnailName.replace("/images/", "/thumbnails/")
                return { id: it.id, name: name, thumb: it.thumbnailName, order: it.order };
              });
              this.sliderImages = res.map((it) => {
                return { id: it.id, name: it.name, order: it.order };
              });
            default:
              break;
          }
          resolve();
        },
        (error: any) => {
          reject(error);
        }
      );
      this.subscriptions.push(subscription);
    });
  }

  private getCustomButtons(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const custumButtonsPublic = this.auctionService.getCustomButtonsPublic(this.auctionCode)
        .subscribe(
          (res: any) => {
            this.customButtons = res;
            resolve(); // Resolve the Promise when the data is retrieved and assigned
          },
          (error: any) => {
            reject(error); // Reject the Promise if an error occurs
          }
        );
      // Add the subscription to the subscriptions array for cleanup
      this.subscriptions.push(custumButtonsPublic);
    });
  }

  ngOnDestroy(): void {
    this.seoService.removeAllMetaTags();
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}

export enum SteppedData {
  auctionLocations = 1,
  photoGallery,
  sliderImages,
  paymentDocuments,
  removalDocuments,
  auctionContacts,
  relatedAuctions,
  partnerLogos,
}
